/*
  perf 30.09 (I8 / D-10): odliczanie do godziny wysyłki (15:00 czasu polskiego) i data dostawy — kod przeniesiony z inline <script>
  w sections/hero-guarantee.liquid (główna, FAQ) i sections/hero-banner-delivery.liquid (porównanie); funkcje 1:1.
  Obie sekcje są pod zgięciem, więc wykonanie z defer (po sparsowaniu strony) nie zmienia tego, co widać przy wejściu.
  Dane z sekcji na #delivery-container: data-part1 / data-part2 (teksty z ustawień), data-nbsp="1" (wariant z twardymi spacjami,
  hero-banner-delivery), data-scrolltop="1" (przycisk .hero-button z href="#" przewija płynnie na górę, jak dotąd w hero-banner-delivery).
*/
(function () {
  function getTimeUntilCutoff() {
    // Czas polski (Europe/Warsaw) niezaleznie od strefy klienta
    const nowPL = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Warsaw' }));
    const currentDay = nowPL.getDay(); // 0 = Niedziela, 1 = Poniedziałek, ..., 6 = Sobota
    const target = new Date(nowPL);
    target.setHours(15, 0, 0, 0);

    // Weekend (sobota lub niedziela) - zawsze odliczamy do poniedziałku 15:00
    if (currentDay === 0 || currentDay === 6) {
      target.setDate(target.getDate() + (8 - currentDay) % 7);
    }
    // Dzień powszedni
    else if (nowPL >= target) {
      // Po 15:00 - odliczamy do następnego dnia roboczego
      if (currentDay === 5) { // Piątek po 15:00 -> poniedziałek
        target.setDate(target.getDate() + 3);
      } else {
        target.setDate(target.getDate() + 1);
      }
    }

    // Stopka 3.0 r5 (26.10): dni wolne w Polsce (11.11, święta) z tej samej funkcji co data dostawy w koszyku
    // (window.svDeliveryCalc, snippets/sv-delivery-estimate-js.liquid); bez niej zostaje liczenie wyżej (same weekendy)
    if (window.svDeliveryCalc && !isNaN(nowPL.getTime())) {
      const s = window.svDeliveryCalc.shipDay(nowPL, 15);
      target.setFullYear(s.getFullYear(), s.getMonth(), s.getDate());
      target.setHours(15, 0, 0, 0);
    }

    const diff = target - nowPL;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  function getDeliveryDate() {
    // Czas polski (Europe/Warsaw) niezaleznie od strefy klienta
    const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Warsaw' }));
    const currentHour = now.getHours();
    const dayOfWeek = now.getDay(); // 0 = Niedziela, 1 = Poniedziałek, ..., 6 = Sobota
    const cutoffTime = 15; // Godzina 15:00 jako granica

    // Określenie daty dostawy zgodnie ze schematem
    let deliveryDate = new Date(now);

    if (dayOfWeek === 1) { // Poniedziałek
      if (currentHour < cutoffTime) {
        deliveryDate.setDate(deliveryDate.getDate() + 1); // Wtorek
      } else {
        deliveryDate.setDate(deliveryDate.getDate() + 2); // Środa
      }
    } else if (dayOfWeek === 2) { // Wtorek
      if (currentHour < cutoffTime) {
        deliveryDate.setDate(deliveryDate.getDate() + 1); // Środa
      } else {
        deliveryDate.setDate(deliveryDate.getDate() + 2); // Czwartek
      }
    } else if (dayOfWeek === 3) { // Środa
      if (currentHour < cutoffTime) {
        deliveryDate.setDate(deliveryDate.getDate() + 1); // Czwartek
      } else {
        deliveryDate.setDate(deliveryDate.getDate() + 2); // Piątek
      }
    } else if (dayOfWeek === 4) { // Czwartek
      if (currentHour < cutoffTime) {
        deliveryDate.setDate(deliveryDate.getDate() + 1); // Piątek
      } else {
        deliveryDate.setDate(deliveryDate.getDate() + 3); // Poniedziałek (nie sobota)
      }
    } else if (dayOfWeek === 5) { // Piątek
      if (currentHour < cutoffTime) {
        deliveryDate.setDate(deliveryDate.getDate() + 3); // Poniedziałek (nie sobota)
      } else {
        deliveryDate.setDate(deliveryDate.getDate() + 4); // Wtorek
      }
    } else if (dayOfWeek === 6) { // Sobota
      deliveryDate.setDate(deliveryDate.getDate() + 3); // Wtorek
    } else if (dayOfWeek === 0) { // Niedziela
      deliveryDate.setDate(deliveryDate.getDate() + 2); // Wtorek
    }
  
    // Stopka 3.0 r5 (26.10): dni wolne w Polsce (11.11, święta) z tej samej funkcji co data dostawy w koszyku
    // (window.svDeliveryCalc, snippets/sv-delivery-estimate-js.liquid); bez niej zostaje liczenie wyżej (same weekendy; w czwartek po 15:00 dawało niedzielę)
    if (window.svDeliveryCalc && !isNaN(now.getTime())) {
      deliveryDate = window.svDeliveryCalc.addWork(window.svDeliveryCalc.shipDay(now, cutoffTime), 1);
    }

    // Formatowanie daty w językach różnych krajów
    const locale = document.documentElement.lang;
    const options = { weekday: 'long', day: 'numeric', month: 'long' };
    const formattedDate = deliveryDate.toLocaleDateString(locale, options);
  
    // Dostosowanie prefiksów dla różnych języków
    if (locale.startsWith('pl')) {
      // Polski
      const [dayName, ...restDate] = formattedDate.split(', ');
      let prefix = 'w ';
      if (dayName === 'wtorek') {
        prefix = 'we ';
      }
      return prefix + dayName.toLowerCase() + ', ' + restDate.join(', ');
    } else if (locale.startsWith('de') || locale.startsWith('at')) {
      // Niemiecki (Niemcy i Austria)
      return 'am ' + formattedDate;
    } else if (locale.startsWith('nl') || locale.startsWith('be')) {
      // Holenderski (Holandia i Belgia)
      return 'op ' + formattedDate;
    } else if (locale.startsWith('es')) {
      // Hiszpański
      return 'el ' + formattedDate;
    } else if (locale.startsWith('cs')) {
      // Czeski
      return 'v ' + formattedDate;
    } else if (locale.startsWith('pt')) {
      // Portugalski
      return 'em ' + formattedDate;
    } else if (locale.startsWith('ro')) {
      // Rumuński
      return 'pe ' + formattedDate;
    } else if (locale.startsWith('fr')) {
      // Francuski (perf 30.09, pakiet 2): „dès le vendredi 2 octobre” — dotąd wpadał w 'on ' (angielski)
      return 'le ' + formattedDate;
    } else if (locale.startsWith('it')) {
      // Włoski (perf 30.09, pakiet 2): „già da venerdì 2 ottobre” — dotąd wpadał w 'on ' (angielski)
      return formattedDate;
    } else {
      // Angielski i inne języki
      return 'on ' + formattedDate;
    }
  }

  // Stopka 3.0 r4 (20.10): poza rynkiem pl dzień wysyłki zamiast daty dostawy (do UE 2-7 dni roboczych, darmowa od 100 €).
  // Dzień roboczy do 15:00 = dziś, pn-czw po 15:00 = jutro, pt po 15:00 i weekend = poniedziałek (czas polski, jak odliczanie).
  function dzienWysylki(c) {
    const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Warsaw' }));
    const d = now.getDay(), h = now.getHours();
    // r5 (26.10): dzień wysyłki z svDeliveryCalc (święta); dzień inny niż dziś i jutro z listy data-dni (locales shop_benefits)
    if (window.svDeliveryCalc && !isNaN(now.getTime())) {
      const s = window.svDeliveryCalc.shipDay(now, 15);
      const n = Math.round((new Date(s.getFullYear(), s.getMonth(), s.getDate()) - new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 864e5);
      const dni = (c.getAttribute('data-dni') || '').split('|');
      if (n === 0) return c.getAttribute('data-dzis') || '';
      if (n === 1) return c.getAttribute('data-jutro') || '';
      if (dni.length === 7 && dni[s.getDay()]) return dni[s.getDay()];
    }
    if (d >= 1 && d <= 5 && h < 15) return c.getAttribute('data-dzis') || '';
    if (d >= 1 && d <= 4) return c.getAttribute('data-jutro') || '';
    return c.getAttribute('data-pon') || '';
  }

  function smoothScrollTop(duration) {
    duration = duration || 1000;
    const startPosition = window.pageYOffset;
    const distance = -startPosition;
    let startTime = null;
  
    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const run = ease(timeElapsed, startPosition, distance, duration);
      window.scrollTo(0, run);
      if (timeElapsed < duration) requestAnimationFrame(animation);
    }
  
    // Funkcja ease dla płynniejszej animacji
    function ease(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    }
  
    requestAnimationFrame(animation);
  }

  function init(container) {
    var part1 = container.getAttribute('data-part1') || '';
    var part2 = container.getAttribute('data-part2') || '';
    var nbsp = container.getAttribute('data-nbsp') === '1';
    var wysylka = container.getAttribute('data-tryb') === 'wysylka';
    if (wysylka) part2 = container.getAttribute('data-wys') || part2;
    function setTime() {
      var t = container.querySelector('#time');
      if (t) t.textContent = getTimeUntilCutoff();
    }
    function update() {
      var deliveryDate = wysylka ? dzienWysylki(container) : getDeliveryDate();
      container.innerHTML = nbsp
        ? '<div>' + part1 + '&nbsp;<span id="time"></span>,&nbsp;' + part2 + ' <span style="color: #D3B186; font-weight: 700;">' + deliveryDate + '</span></div>'
        : '<div>' + part1 + ' <span id="time"></span>, ' + part2 + ' <span style="color: #D3B186; font-weight: 700;">' + deliveryDate + '</span></div>';
      setTime();
    }
    update();
    // Pełna aktualizacja co minutę (i przez pierwszą minutę każdej godziny — jak dotąd), w pozostałe sekundy tylko odliczanie
    setInterval(function () {
      var now = new Date();
      if (now.getSeconds() === 0 || now.getMinutes() === 0) {
        update();
      } else {
        setTime();
      }
    }, 1000);
  }

  function start() {
    // R1-09: plik bywa dołączony 2× (hero-guarantee i hero-banner-delivery na jednej stronie) — każdy kontener i przycisk tylko raz
    document.querySelectorAll('[data-sv-delivery]').forEach(function (container) {
      if (container.dataset.svDeliveryReady) return;
      container.dataset.svDeliveryReady = '1';
      init(container);
    });
    if (window.__svDeliveryScrollTop) return;
    if (document.querySelector('[data-sv-delivery][data-scrolltop="1"]')) {
      window.__svDeliveryScrollTop = true;
      var btn = document.querySelector('.hero-button');
      if (btn) {
        btn.addEventListener('click', function (e) {
          if (this.getAttribute('href') === '#') {
            e.preventDefault();
            smoothScrollTop(1000);
          }
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
